// src/store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import userSlice from './userSlice';
import entitySlice from './entitySlice';
import systemServiceSlice from './systemServiceSlice';
import systemSlice from './systemSlice';
import projectsSlice from './projectsSlice';
import alternativesSlice from './alternativeSlice';
const store = configureStore({
  reducer: {
    user: userSlice,
    entity: entitySlice,
    systemService: systemServiceSlice,
    system: systemSlice,
    projects: projectsSlice,
    alternatives: alternativesSlice
  },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware().concat(MIDDLEWARE NAME IF WE WILL USE THAT),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
